import { useState, useEffect } from 'react';
import { useThemeLanguage } from '@/contexts/ThemeLanguageContext';
import { getImpersonationTokenKey, clearImpersonation } from '@/utils/authToken';
import './ImpersonationBanner.css';

function decodeUidFromToken(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.impersonated_uid ?? payload.firebase_uid ?? payload.sub ?? null;
  } catch {
    return null;
  }
}

export function ImpersonationBanner() {
  const { t } = useThemeLanguage();
  const [uid, setUid] = useState<string | null>(null);

  useEffect(() => {
    const key = getImpersonationTokenKey();
    const token = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(key) : null;
    setUid(token ? decodeUidFromToken(token) : null);
  }, []);

  if (!uid) return null;

  return (
    <div className="impersonation-banner" role="banner">
      <span>{t('admin.impersonation.label', { uid })}</span>
      <button type="button" className="impersonation-banner-exit" onClick={() => clearImpersonation(true)}>
        {t('admin.impersonation.exit')}
      </button>
    </div>
  );
}
